var map = {
	"./auction-points.svg": 1642,
	"./auction.svg": 7585,
	"./auctionPoint.svg": 6055,
	"./highlight.svg": 1170,
	"./offers.svg": 9193,
	"./paid.svg": 3843,
	"./premium-highlight.svg": 7577,
	"./premium.svg": 3902,
	"./publication.svg": 8269,
	"./standard.svg": 5788,
	"./top.svg": 1794,
	"./top3.svg": 1142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4237;